<div class="ui-modal" [class.is-open]="isOpen">
  <div (click)="close()" class="ui-modal__overlay"></div>
  <div class="ui-modal__window" [ngClass]="modalWidth ? 'ui-modal--' + modalWidth : ''">
    <ng-content></ng-content>
  </div>
</div>
